import { authedFetch } from "../../../../common/http_service";

/**
 * Beta deployment of the editor — "Beta'ya Geç" opens the same training there.
 * The hand-off code only redeems on the mw that minted it, so the target must
 * share this build's mw: prod → studiobeta (both on mw.aideapro.ai). Override
 * per env with BETA_STUDIO_URL — locally `http://127.0.0.1:8080` reproduces the
 * cross-origin hop (own localStorage, no token) against the same local mw.
 */
export const BETA_ORIGIN = new URL(process.env.BETA_STUDIO_URL || "https://studiobeta.aideapro.ai")
  .origin;

/**
 * Same path + query on the beta origin, so it works from any host (prod,
 * localhost, custom domains). The live training id wins over the URL's (a
 * training created in-session never had ?id=). The raw session token is never
 * put in the URL: a stale ?token=/?code= is dropped and only a freshly minted
 * one-time `code` is attached.
 */
export const buildBetaUrl = (code) => {
  const params = new URLSearchParams(window.location.search);
  params.delete("token");
  params.delete("code");
  if (window.idealStudioTrainingId) params.set("id", window.idealStudioTrainingId);
  if (code) params.set("code", code);
  const query = params.toString();
  return `${BETA_ORIGIN}${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
};

/**
 * Mints a one-time, 60s hand-off code (mw POST /auth/session-code) that beta
 * redeems at boot via setEnvironmentFromUrl's ?code= exchange — beta has its
 * own localStorage, so without it the author would have to sign in again.
 * Minted on the same mw the exchange defaults to (we forward ?baseUrl= as is).
 * Best-effort: any failure resolves to null and beta falls back to sign-in.
 */
export const mintSessionCode = async () => {
  try {
    const base = (window.ideaLibraryRootUrl || process.env.MW_API_URL || "").replace(/\/+$/, "");
    const response = await authedFetch(`${base}/api/auth/session-code`, { method: "POST" });
    if (!response.ok) return null;
    const data = await response.json();
    return data && typeof data.code === "string" ? data.code : null;
  } catch (e) {
    console.warn("Beta hand-off code could not be minted:", e);
    return null;
  }
};

export const switchToBeta = async () => {
  const code = await mintSessionCode();
  window.location.assign(buildBetaUrl(code));
};
